import { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { PlanIdsContext } from './PlanIdsContext.tsx'

function useAccountBranchIdsParams() {
  const injected = useContext(PlanIdsContext)
  const { accountId, branchId } = useParams()

  const resolvedAccountId =
    injected?.accountId ?? (accountId ? parseInt(accountId) : undefined)
  const resolvedBranchId =
    injected?.branchId ?? (branchId ? parseInt(branchId) : undefined)

  if (!resolvedAccountId) {
    throw new Error('Account ID is required')
  }

  if (!resolvedBranchId) {
    throw new Error('Branch ID is required')
  }

  return { accountId: resolvedAccountId, branchId: resolvedBranchId }
}

export { useAccountBranchIdsParams }
